import { ChangeEventHandler, FC, Fragment } from 'react';

import TextField from '@mui/material/TextField';

import { AddFreeSpinsForm } from '../../form';

import { Select } from 'v2/components/select/Select';
import { EvoplayFreeSpinsType } from 'v2/constants';
import { SelectOption } from 'v2/types';
import { EvoplayGameFreeSpinInfoModel } from 'v2/types/FreeSpinModel';
import { identifyArrayToSelect } from 'v2/utils';

interface EvoplayFreeSpinsParamProps {
  info: EvoplayGameFreeSpinInfoModel;
  values: AddFreeSpinsForm;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onSelectChange: (field: keyof AddFreeSpinsForm) => (v: unknown) => void;
  betOptions: SelectOption<number>[];
}

export const EvoplayFreeSpinsParam: FC<EvoplayFreeSpinsParamProps> = ({
  info,
  values,
  onChange,
  onSelectChange,
  betOptions,
}) => (
  <Fragment>
    <Select
      value={values.typeSpins}
      options={identifyArrayToSelect(info.availableFreeSpinsTypes)}
      label="Spin Type"
      onChange={onSelectChange('typeSpins')}
      required
    />

    <div className="form-group">
      {values.typeSpins === EvoplayFreeSpinsType.FREESPINS_ON_START ? (
        <Select
          value={values.countSpins}
          options={identifyArrayToSelect(info.availableFreeSpinsOnStartCount)}
          label="Spins Count"
          onChange={onSelectChange('countSpins')}
          required
        />
      ) : (
        <TextField
          name="countSpins"
          value={values.countSpins}
          label="Spins Count"
          onChange={onChange}
          type="number"
          required
          fullWidth
        />
      )}

      <Select
        value={!values.betSpins ? undefined : values.betSpins}
        options={betOptions}
        label="Bet"
        onChange={onSelectChange('betSpins')}
        required
      />
    </div>
  </Fragment>
);
